import React from 'react';
import { ErrorContainer } from 'src/shared/components/error-container';

export const ErrorPage = () => <ErrorContainer />;
